.xySeriesChart {
  .visx-line {
    stroke-dasharray: 4;
    color: #E4E4E4;
  }

  .visx-axis-line {
    stroke-dasharray: none;
  }

  .bookmark-svg-icon .fill {
    fill: #FF754C;
  }

  .visx-bar {
    rx: 4;
    ry: 4;
  }
}

.xy-series-chart-tooltip {
  position: fixed !important;
}

.horizontalBarChart {
  .chartLabel {
    fill: rgb(11 4 52 / 70%);
  }
}